import { Code, HelpSection, Note, P, Screen, SeeAlso, Strong, Terms } from '../prose';

/**
 * プランとシート。
 *
 * 「ロールがそのままプランである」ことが要点。ここを 2 つの軸だと思われると、
 * 枠の計算が合わない理由が分からなくなる。
 */
export function PlansAndSeatsArticle() {
  return (
    <>
      <HelpSection heading="プランはロールで決まる">
        <P>
          {
            'プランを人ごとに選ぶ設定はありません。その人のロールが、そのままどちらのシートを使うかを決めます。2 つのプランは同じ組織の中で併用できます。'
          }
        </P>
        <Terms
          rows={[
            {
              term: 'MCP Connect',
              value: (
                <>
                  {'ロール '}
                  <Code>mcp</Code>
                  {' の人が使う枠です。MCP 接続と、自分の工数・稼働だけを扱えます。'}
                </>
              ),
            },
            {
              term: 'Full Management',
              value: (
                <>
                  {'ロール '}
                  <Code>member</Code>
                  {' と '}
                  <Code>admin</Code>
                  {' が使う枠です。管理画面をひととおり使えます。マスタの編集ができるのは '}
                  <Code>admin</Code>
                  {' だけです。'}
                </>
              ),
            },
          ]}
        />
        <P>
          {
            'ロールを変えると、消費する枠も変わります。移動先の枠に空きが無いと変更はできないので、先に枠を増やしてください。'
          }
        </P>
      </HelpSection>

      <HelpSection heading="シートを消費するタイミング">
        <Terms
          rows={[
            {
              term: '招待した時点',
              value:
                '相手が受諾する前から 1 枠を消費します。枠を押さえずに招待だけを出せると、購入した枠を超えて人を集められてしまうためです。',
            },
            {
              term: '無効にしたら戻る',
              value:
                '利用者を無効にすると枠が空きます。退職者は削除せず無効にしておくと、その人の記録を残したまま枠だけを返せます。',
            },
          ]}
        />
        <P>
          {'いま何枠使っているかは '}
          <Screen to="/members">メンバー</Screen>
          {' の上部に種別ごとに出ています。'}
        </P>
      </HelpSection>

      <HelpSection heading="トライアルが終わったら">
        <P>
          {'トライアル期間が終わり、購入した枠が 1 つも無い状態になると、'}
          <Strong>参照はできますが更新ができなくなります</Strong>
          {'。レポートも過去の記録もそのまま見られます。'}
        </P>
        <P>
          {
            '止まるのは、工数の記録・マスタの編集・MCP 接続です。期限が切れた瞬間に自分のデータが見えなくなることは無いようにしてあります。'
          }
        </P>
        <Note label="別の組織を立てるとき">
          <P>
            {
              '期限が切れたあとでも、同じブラウザから新しい組織を申し込めます。申し込みはいまの組織には影響しません。'
            }
          </P>
        </Note>
      </HelpSection>

      <HelpSection heading="アカウントまわり">
        <Terms
          rows={[
            {
              term: '1 つのメールで 1 つの組織',
              value:
                '同じメールアドレスを 2 つの組織に登録することはできません。別の組織に参加するときは別のアドレスを使ってください。',
            },
            {
              term: 'パスワードを忘れたとき',
              value:
                '管理者が代わりに再設定することはできません。リカバリーコードで本人が復旧します（管理者による成りすましと二要素認証の迂回を塞ぐためです）。',
            },
            {
              term: 'ログイン中の端末',
              value: (
                <>
                  <Screen to="/settings/account">アカウント</Screen>
                  {
                    ' から自分のセッションを一覧して、個別に切れます。管理者でも他の人の端末は切れません（そちらは無効化で止めます）。'
                  }
                </>
              ),
            },
          ]}
        />
        <P>
          {'用語の意味は '}
          <SeeAlso slug="glossary">用語集</SeeAlso>
          {' にまとめてあります。'}
        </P>
      </HelpSection>
    </>
  );
}
